import { SizeInput } from "./SizeInput";
import { ZElement } from "../arrangement/ZElement";

export function GehflügelBreitenEingabe({ tor }: { tor: ZElement }) {
  if (!tor.isDoppeltor || tor.size == null) {
    return null;
  }

  const minMaxBox = tor.sizeRange.flügelBox;
  return (
    <div className={"Auswahl"} role="group" aria-labelledby="gehfluegel-label">
      <div className="Headline">
        <label id="gehfluegel-label">
          <span dangerouslySetInnerHTML={{ __html: I18N("Gehflügelbreite") }}></span>
        </label>
      </div>
      <SizeInput
        key={tor.id + ".gehflügel_x"}
        axis="x"
        value={tor.gehflügelbreite}
        setter={(value) => (tor.gehflügelbreite = value)}
        disabled={!tor.isBreiteKonfigurierbar || !(minMaxBox.min.x + 0.001 < minMaxBox.max.x)}
        min={minMaxBox.min.x}
        max={minMaxBox.max.x}
      />
    </div>
  );
}
